// ADR 23.9.26v §3 — `navigator.storage.persist()`, asked for only by an
// installed app. There eviction would break a promise, and Chromium grants the
// request silently; in a browser tab Firefox prompts for it, which is noise on
// a page nobody installed. Standalone is W1's one reader (`displayModeOf`,
// which also reads iOS's legacy `navigator.standalone` — the platform that
// most needs the guard). The result is not recorded.

import { displayModeOf, type DisplayModeWindow } from '../pwa/displayMode'

interface StorageWindow extends DisplayModeWindow {
  navigator: { storage?: { persist?: () => Promise<boolean> } }
}

const asked = new WeakSet<object>()

/** Once per window, after the first successful persist; never throws. */
export function requestPersistentStorage(win: StorageWindow): void {
  if (asked.has(win) || displayModeOf(win) !== 'standalone') return
  const persist = win.navigator.storage?.persist
  if (persist === undefined) return
  asked.add(win)
  persist.call(win.navigator.storage).catch(() => {
    // Refused or unsupported: the cache still works, it is merely evictable.
  })
}
